import { render, staticRenderFns } from "./widget-settings-group.vue?vue&type=template&id=8fcad01e&"
import script from "./widget-settings-group.vue?vue&type=script&lang=js&"
export * from "./widget-settings-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports